setTimeout(() => {
  const waitForSwiper = setInterval(() => {
    const el = document.querySelector('.product__media-container.below-mobile.carousel');
    if (el && el.swiper) {
      clearInterval(waitForSwiper);
      el.swiper.on('slideChangeTransitionEnd', () => {
        document.querySelectorAll('.plyr__control').forEach(btn => {
          btn.classList.add('show-btn');
        });
      });
      document.addEventListener('click', function (e) {
        console.log(e);
        if (e.target.classList.contains('plyr__control')) {
          e.target.classList.remove('show-btn');
        }
      });
      document.querySelectorAll('.plyr__control').forEach(btn => {
        btn.classList.add('show-btn');
      });
    }
  }, 300);
}, 1500);


// PDP Desc Read more Logic
document.addEventListener("DOMContentLoaded", function () {
  const mql = window.matchMedia("(max-width: 767px)");

  function setupMobileToggle() {
    if (mql.matches) {
      const readMore = document.getElementById("read-more");
      const readLess = document.getElementById("read-less");
      const truncated = document.getElementById("truncated-description");
      const fullMobile = document.getElementById("full-description-mobile");

      if (readMore && fullMobile) {
        readMore.onclick = () => {
          truncated.style.display = "none";
          fullMobile.style.display = "block";
        };
        readLess.onclick = () => {
          fullMobile.style.display = "none";
          truncated.style.display = "block";
        };
      }
    }
  }

  setupMobileToggle();
  
  mql.addEventListener("change", setupMobileToggle);
});


// Mobile collection: theme-styled sort dropdown (not OS-native).
// - Click toggle: open/close the dropdown
// - Click an option: update ?sort_by= and reload (preserves filters, drops page)
// - Click outside / Escape: close
(function () {
  var openDropdown = null;

  function setOpen(wrapper, open) {
    if (!wrapper) return;
    var toggle = wrapper.querySelector('[data-mobile-sort-toggle]');
    var list = wrapper.querySelector('[data-mobile-sort-list]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (list) list.setAttribute('aria-hidden', open ? 'false' : 'true');
    openDropdown = open ? wrapper : null;
  }

  function closeAll() {
    document.querySelectorAll('[data-mobile-sort-dropdown]').forEach(function (w) {
      setOpen(w, false);
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-mobile-sort-toggle]');
    if (toggle) {
      e.preventDefault();
      var wrapper = toggle.closest('[data-mobile-sort-dropdown]');
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeAll();
      if (!isOpen) setOpen(wrapper, true);
      return;
    }

    var option = e.target.closest && e.target.closest('[data-mobile-sort-option]');
    if (option) {
      e.preventDefault();
      var value = option.getAttribute('data-sort-value');
      try {
        var url = new URL(window.location.href);
        if (value) {
          url.searchParams.set('sort_by', value);
        } else {
          url.searchParams.delete('sort_by');
        }
        url.searchParams.delete('page');
        window.location.href = url.toString();
      } catch (err) {
        window.location.search = 'sort_by=' + encodeURIComponent(value);
      }
      return;
    }

    // Click outside any open dropdown closes it
    if (openDropdown && !e.target.closest('[data-mobile-sort-dropdown]')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDropdown) closeAll();
  });
})();


// Pause / Play Icon
window.Shopify.loadFeatures(
  [{ name: "video-ui", version: "1.0" }],
  function () {
    document.querySelectorAll('.media[data-interactive] video').forEach(video => {
      if (!video.closest('.plyr')) {
        new Shopify.Plyr(video, {
          loop: { active: video.closest('.media')?.dataset.loop === "true" }
        });
      }
    });
  }
);
